import React from "react";
import { INITIAL_RESULT_MESSAGE } from "./constants";

export default function ChiikiSearchResult({ viewState }) {
  return (
    <div className="result">
      <div>
        <ResultContent viewState={viewState} />
      </div>
    </div>
  );
}

function ResultContent({ viewState }) {
  if (viewState.status === "error") {
    return <span className="error">{viewState.message}</span>;
  }

  if (viewState.status === "success") {
    const codeText = viewState.code || "取得できませんでした";
    return (
      <>
        地域区分は<span className="highlight">{viewState.chiiki}</span>
        です。地域区分コードは{codeText}
      </>
    );
  }

  if (viewState.status === "notFound") {
    return <>地域区分が取得できませんでした。</>;
  }

  return <>{viewState.message || INITIAL_RESULT_MESSAGE}</>;
}
